module.exports = __webpack_public_path__ + "img/404.a58ea76e.svg";